/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';
import { UserType } from '../../../../@shelter/enums/user-type.enum';

export const defaultNavigation: FuseNavigationItem[] = [

    {
        id: 'users',
        title: 'Users',
        icon: 'mat_outline:save',
        type: 'group',
        permissions: [UserType.Admin],
      children: [
        {
            id: 'users',
            title: 'Users',
            type: 'basic',
            icon: 'mat_outline:group',
            link: '/Users',
            permissions: [UserType.Admin],
    
        },
      ]  
    },
    {
        id: 'basicData',
        title: 'Basic Data',
        icon: 'mat_outline:save',
        type: 'group',
        permissions: [UserType.Admin],
        children: [
            {

                id: 'basicData.Artists',
                title: 'Artists',
                type: 'basic',
                icon: 'mic_external_on',
                link: '/Artist',
                permissions:[UserType.Admin],
            
            },
            {
        
                id: 'basicData.PromoCodes',
                title: 'PromoCodes',
                type: 'basic',
                icon: 'local_offer',
                link: '/PromoCodes',
                permissions:[UserType.Admin],
            
            },
            {
                id: 'basicData.banners',
                title: 'Banners',
                type: 'basic',
                icon: 'mat_outline:featured_video',
                link: '/Banner',
                permissions: [UserType.Admin]
            },
            {
                id: 'basicData.cities',
                title: 'Cities',
                type: 'basic',
                icon: 'mat_outline:location_city',
                link: '/City',
                permissions: [UserType.Admin]
            },
            {
                id: 'basicData.sponsers',
                title: 'Sponsors',
                type: 'basic',
                icon: 'mat_outline:paid',
                link: '/Sponsor',
                permissions:[UserType.Admin],

            },
            {
                id: 'basicData.eventCategory',
                title: 'Event Categories',
                type: 'basic',
                icon: 'mat_outline:calendar_view_month',
                link: '/EventCategory',
                permissions:[UserType.Admin],
            },



        ]
    },
    {
        id: 'charts.charts',
        title: 'Seat Maps',
        icon: 'mat_outline:account_tree',
        type: 'group',  
        permissions: [UserType.Admin],
        children:[ {
            id: 'charts.charts',
            title: 'Seat Maps',
            type: 'basic',
            icon: 'mat_outline:account_tree',
            link: '/Chart',
            permissions: [UserType.Admin],
            children:[]
        },]
    },
    {
        id: 'events.event',
        title: 'Events',
        type: 'group',  
        icon: 'mat_outline:local_activity',
        permissions:[UserType.Admin,UserType.Supplier],
        children:[
            {
                id: 'events.event',
                title: 'Events',
                type: 'basic',
                icon: 'mat_outline:local_activity',
                link: '/Event',
                permissions:[UserType.Admin,UserType.Supplier],
        
            },
        ]
    },
    {
        id: 'basicData.onBoarding',
        title: 'contact us',
        type: 'group',  
        icon: 'mat_outline:ad_units',
        link: '/contact-us',
        permissions:[UserType.Admin],
            
        children: [
                {
                    id: 'basicData.onBoarding',
                    title: 'contact us',
                    type: 'basic',
                    icon: 'mat_outline:ad_units',
                    link: '/contact-us',
                    permissions:[UserType.Admin],
            
                }
            
        ]
    }
   
   
    

    // {
    //     id: 'users',
    //     title: 'Users',
    //     icon: 'mat_outline:group',
    //     type: 'group',
    //     permissions: [UserType.Admin],
    //     children: [
    //         {
    //             id: 'users.admin',
    //             title: 'Admins',
    //             type: 'basic',
    //             icon: 'mat_outline:group',
    //             link: '/User/all/Admin',
    //             permissions: [UserType.Admin]
    //         },
    //         {
    //             id: 'users.seller',
    //             title: 'Sellers',
    //             type: 'basic',
    //             icon: 'mat_outline:group',
    //             link: '/User/all/Seller',
    //             permissions: [UserType.Admin]
    //         },
    //         {
    //             id: 'users.supplier',
    //             title: 'Suppliers',
    //             type: 'basic',
    //             icon: 'mat_outline:group',
    //             link: '/User/all/Supplier',
    //             permissions: [UserType.Admin]
    //         },
    //         {
    //             id: 'users.organizer',
    //             title: 'Organizers',
    //             type: 'basic',
    //             icon: 'mat_outline:group',
    //             link: '/User/all/Organizer',
    //             permissions: [UserType.Admin]
    //         },
    //         // {
    //         //     id: 'users.auditor',
    //         //     title: 'Auditors',
    //         //     type: 'basic',
    //         //     icon: 'mat_outline:group',
    //         //     link: '/User/all/Auditor',
    //         //     permissions: [UserType.Admin]
    //         // },
    //         {
    //             id: 'users.user',
    //             title: 'Users',
    //             type: 'basic',
    //             icon: 'mat_outline:group',
    //             link: '/User/all/User',
    //             permissions: [UserType.Admin]
    //         },

    //     ]
    // },


];
export const compactNavigation: FuseNavigationItem[] = [

];
export const futuristicNavigation: FuseNavigationItem[] = [

];
export const horizontalNavigation: FuseNavigationItem[] = [
    // {
    //     id: 'users',
    //     title: 'Users',
    //     type: 'group',
    //     icon: 'mat_outline:group',
    //     // link: '/User',
    //     permissions: [UserType.Admin],
    //     children: []

    // },
    {
        id: 'users',
        title: 'Users',
        type: 'basic',
        icon: 'mat_outline:group',
        link: '/Users',
        permissions: [UserType.Admin],

    },
    {
        id: 'basicData',
        title: 'Basic Data',
        icon: 'mat_outline:save',
        type: 'group',
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
        ,
        permissions: [UserType.Admin],

    },
    // {
    //     id: 'basicData.onBoarding',
    //     title: 'Welcome Pages',
    //     type: 'basic',
    //     icon: 'mat_outline:ad_units',
    //     link: '/WelcomePage',
    //     permissions:[UserType.Admin],

    // },




    // {
    //     id      : 'events',
    //     title   : 'Events',
    //     icon    : 'mat_outline:event',
    //     type    : 'group',
    //     children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    // },


    // {
    //     id   : 'events.ticektCategory',
    //     title: 'Ticket Categories',
    //     type : 'basic',
    //     icon : 'mat_outline:confirmation_number',
    //     link : '/TicketCategory'
    // },
    {
        id: 'charts.charts',
        title: 'Seat Maps',
        type: 'basic',
        icon: 'mat_outline:account_tree',
        link: '/Chart',
        permissions: [UserType.Admin]
    },
    {
        id: 'events.event',
        title: 'Events',
        type: 'basic',
        icon: 'mat_outline:local_activity',
        link: '/Event',
        permissions:[UserType.Admin,UserType.Supplier],

    },
    // {
    //     id: 'roles.role',
    //     title: 'Roles & Permissions',
    //     type: 'basic',
    //     icon: 'mat_outline:lock_open',
    //     link: '/Role',
    //     permissions:[UserType.Admin,UserType.Supplier],

    // },
    // {
    //     id: 'events.settings',
    //     title: 'settings',
    //     type: 'basic',
    //     icon: 'mat_outline:settings',
    //     link: '/Settings',
    //     permissions:[UserType.Admin],

    // },
    {
        id: 'basicData.onBoarding',
        title: 'contact us',
        type: 'basic',
        icon: 'mat_outline:ad_units',
        link: '/contact-us',
        permissions:[UserType.Admin],

    },


];
